import { ProductModel } from './product-model';
import { Type } from '@angular/core';
import { Tranquility30SeComProductModelComponent } from './clm/tranquility-30-se-com-product-model/tranquility-30-se-com-product-model.component';
import { Tranquility30SeResProductModelComponent } from './clm/tranquility-30-se-res-product-model/tranquility-30-se-res-product-model.component';
import { Tranquility18ScComProductModelComponent } from './clm/tranquility-18-sc-com-product-model/tranquility-18-sc-com-product-model.component';
import { Tranquility18SrComProductModelComponent } from './clm/tranquility-18-sr-com-product-model/tranquility-18-sr-com-product-model.component';
import { Tranquility24SyComProductModelComponent } from './clm/tranquility-24-sy-com-product-model/tranquility-24-sy-com-product-model.component';
import { Tranquility24SzComProductModelComponent } from './clm/tranquility-24-sz-com-product-model/tranquility-24-sz-com-product-model.component';
import { TranquilityConsoleSdComProductModelComponent } from './clm/tranquility-console-sd-com-product-model/tranquility-console-sd-com-product-model.component';
import { TranquilityRooftopStComProductModelComponent } from './clm/tranquility-rooftop-st-com-product-model/tranquility-rooftop-st-com-product-model.component';
import { TranquilitySbComProductModelComponent } from './clm/tranquility-sb-com-product-model/tranquility-sb-com-product-model.component';
import { TranquilityW2wSwComProductModelComponent } from './clm/tranquility-w2w-sw-com-product-model/tranquility-w2w-sw-com-product-model.component';
import { Tranquility24SzResProductModelComponent } from './clm/tranquility-24-sz-res-product-model/tranquility-24-sz-res-product-model.component';
import { TranquilityW2wSwResProductModelComponent } from './clm/tranquility-w2w-sw-res-product-model/tranquility-w2w-sw-res-product-model.component';
import { TranquilitySpResProductModelComponent } from './clm/tranquility-sp-res-product-model/tranquility-sp-res-product-model.component';
import { TranquilitySjResProductModelComponent } from './clm/tranquility-sj-res-product-model/tranquility-sj-res-product-model.component';
import { TranquilitySaResProductModelComponent } from './clm/tranquility-sa-res-product-model/tranquility-sa-res-product-model.component';
import { TranquilitySkResProductModelComponent } from './clm/tranquility-sk-res-product-model/tranquility-sk-res-product-model.component';
import { TrilogySvResProductModelComponent } from './clm/trilogy-sv-res-product-model/trilogy-sv-res-product-model.component';
import { TranquilityVerticalSmComProductModelComponent } from './clm/tranquility-vertical-sm-com-product-model/tranquility-vertical-sm-com-product-model.component';
import { TranquilityVerticalShComProductModelComponent } from './clm/tranquility-vertical-sh-com-product-model/tranquility-vertical-sh-com-product-model.component';
import { TranquilityTfcResProductModelComponent } from './clm/tranquility-tfc-res-product-model/tranquility-tfc-res-product-model.component';
import { TranquilitySlComProductModelComponent } from './clm/tranquility-sl-com-product-model/tranquility-sl-com-product-model.component';
import { UnknownProductModelComponent } from './unknown-product-model/unknown-product-model.component';
import { TranquilitySwtComProductModelComponent } from './clm/tranquility-swt-com-product-model/tranquility-swt-com-product-model.component';

export class ProductModelFactory {
  static buildComponent(productId: string): Type<ProductModel> {
    switch (productId) {
      case 'Tranquility30-SE-COM':
        return Tranquility30SeComProductModelComponent;
      case 'Tranquility30-SE-RES':
        return Tranquility30SeResProductModelComponent;
      case 'Tranquility18-SC-COM':
        return Tranquility18ScComProductModelComponent;
      case 'Tranquility18-SR-COM':
        return Tranquility18SrComProductModelComponent;
      case 'Tranquility24-SY-COM':
        return Tranquility24SyComProductModelComponent;
      case 'Tranquility24-SZ-COM':
        return Tranquility24SzComProductModelComponent;
      case 'TranquilityConsole-SD-COM':
        return TranquilityConsoleSdComProductModelComponent;
      case 'TranquilityRoofTop-ST-COM':
        return TranquilityRooftopStComProductModelComponent;
      case 'Tranquility-SB-COM':
        return TranquilitySbComProductModelComponent;
      case 'TranquilityW2W-SW-COM':
        return TranquilityW2wSwComProductModelComponent;
      case 'Tranquility24-SZ-RES':
        return Tranquility24SzResProductModelComponent;
      case 'TranquilityW2W-SW-RES':
        return TranquilityW2wSwResProductModelComponent;
      case 'Tranquility-SP-RES':
        return TranquilitySpResProductModelComponent;
      case 'Tranquility-SJ-RES':
        return TranquilitySjResProductModelComponent;
      case 'Tranquility-SA-RES':
        return TranquilitySaResProductModelComponent;
      case 'Tranquility-SK-RES':
        return TranquilitySkResProductModelComponent;
      case 'Trilogy-SV-RES':
        return TrilogySvResProductModelComponent;
      case 'TranquilityVertical-SM-COM':
        return TranquilityVerticalSmComProductModelComponent;
      case 'TranquilityVertical-SH-COM':
        return TranquilityVerticalShComProductModelComponent;
      case 'Tranquility-TFC-RES':
        return TranquilityTfcResProductModelComponent;
      case 'Tranquility-SL-COM':
        return TranquilitySlComProductModelComponent;
      case 'Tranquility-SWT-COM':
        return TranquilitySwtComProductModelComponent;
      default:
        return UnknownProductModelComponent;
    }
  }
}
